import { render, staticRenderFns } from "./SaleHistory.vue?vue&type=template&id=019bce5a&scoped=true"
import script from "./SaleHistory.vue?vue&type=script&lang=js"
export * from "./SaleHistory.vue?vue&type=script&lang=js"
import style0 from "./SaleHistory.vue?vue&type=style&index=0&id=019bce5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019bce5a",
  null
  
)

export default component.exports